import React, {useEffect, useState} from 'react';

const SITE_KEY = window.Site?.authRecaptcha;
const isReady = () =>
  typeof window !== 'undefined' &&
  typeof window.grecaptcha !== 'undefined' &&
  typeof window.grecaptcha.execute !== 'undefined';

let readyCheck;

export const loadRecaptcha = (id, siteKey = SITE_KEY) => {
  if (!document.getElementById(id)) {
    const script = document.createElement('script');

    script.id = id;

    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;

    document.body.appendChild(script);
  }
};

export const getCaptchaToken = (action, sitekey = SITE_KEY) => () => {
  if (isReady()) {
    return window.grecaptcha?.execute(sitekey, {action});
  }
};

export const Recaptcha = ({elementID = 'g-recaptcha'}) => {
  const [ready, setReady] = useState(isReady());

  const handleUpdateReadyState = () => {
    if (isReady()) {
      setReady(true);

      clearInterval(readyCheck);
    }
  };

  useEffect(() => {
    if (!ready) {
      readyCheck = setInterval(handleUpdateReadyState, 1000);
    }

    return () => {
      clearInterval(readyCheck);
    };
  }, []);

  return ready
    ? <div id={elementID} className='g-recaptcha' />
    : null;
};
